import ArchiveModalWrapper from "app/containers/Features/components/ArchiveModalWrapper";
import { actions as memberActions } from "app/containers/Features/components/MemberSelection/redux/slice";
import { handleCopyBoardLink } from "app/containers/Features/containers/Boards/helpers";
import { actions } from "app/containers/Features/containers/Boards/redux/slice";
import {
  Board,
  FavoriteTypeEnum,
} from "app/containers/Features/containers/Boards/types";
import { useUpdateFavorite } from "app/hooks/useUpdateFavorite";
import { actions as appActions } from "app/redux/slice";
import { ArchiveType } from "app/types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Row from "./Row";

export default function Rows({ boards }: { boards: Board[] }) {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [archiveModal, setArchiveModal] = useState(false);
  const [selectedBoard, setSelectedBoard] = useState<Board | null>(null);
  const [editingBoardId, setEditingBoardId] = useState<string | null>(null);

  const handleOnArchive = (board: Board) => {
    setArchiveModal(true);
    setSelectedBoard(board);
  };

  const handleBoardRename = (board: Board) => {
    // Toggle edit mode for the clicked board, ensuring only one board is editable at a time
    setEditingBoardId((prevId) => (prevId === board?._id ? null : board?._id));
  };

  const { updateFavorite } = useUpdateFavorite();

  const handleFavoriteBoard = (board: Board) => {
    updateFavorite(board._id, FavoriteTypeEnum.BOARD);
  };

  const handleDuplicateBoard = (board: Board) => {
    dispatch(actions.duplicateBoard({ id: board._id }));
  };
  const handleArchive = () => {
    dispatch(actions.archiveBoard(selectedBoard?._id || ""));
    dispatch(appActions.setArchiveBoardMenu(selectedBoard?._id || ""));
    dispatch(
      appActions.doArchive({
        projectId: params?.project || "",
        dataId: [selectedBoard?._id || ""],
        dataType: ArchiveType.BOARD,
        callback() {},
      }),
    );
    setArchiveModal(false);
  };

  useEffect(() => {
    dispatch(
      memberActions.fetchProjectMembersList({
        id: params.project as string,
        callback() {},
      }),
    );

    return () => {};
  }, []);
  const handleRedirectToBoard = (board: Board) => {
    dispatch(
      appActions.updateBoardOrderFromHome({
        board,
      }),
    );
    const base = `/app/${params.project}/${params.team}/boards/${board._id}`;
    const path = `${base}/${board?.viewType}/board`;
    navigate(path);
  };
  return (
    <>
      {boards.map((board) => (
          <Row
            key={board._id}
            board={board}
            onArchive={() => handleOnArchive(board)}
            handleBoardRename={() => handleBoardRename(board)}
            handleCopyBoardLink={() =>
              handleCopyBoardLink(board, params?.project, params?.team)
            }
            isEditing={editingBoardId === board._id}
            setEditingBoardId={setEditingBoardId}
            handleFavoriteBoard={() => handleFavoriteBoard(board)}
            handleDuplicateBoard={() => handleDuplicateBoard(board)}
            handleRedirectToBoard={() => handleRedirectToBoard(board)}
          />
        ))}

      {archiveModal && (
        <ArchiveModalWrapper
          onClose={() => setArchiveModal(false)}
          content={`Are you sure that you want to archive <span class=" !font-medium">${selectedBoard?.name}</span>?`}
          onSave={() => {
            handleArchive();
          }}
          title="Archive board"
        />
      )}
    </>
  );
}
